export function formatName(name: string, maxSize: number): string {
    if(name === undefined) return name;
    const nameSize = name.length;
    return (nameSize > maxSize ? name.substring(0, maxSize) + '...' : name);
}